import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';

const VERIFY_EMAIL = gql`
  mutation ($email: String!, $submissionCode: String!) {
    verifyEmail(email: $email, submissionCode: $submissionCode)
  }
`;

export type VerifyEmailResponse = {
  code: string;
  message: string;
  details?: string;
  status?: string;
};

export const useVerifyEmail = async (
  client: ApolloClient<NormalizedCacheObject>,
  email: string,
  submissionCode: string,
): Promise<VerifyEmailResponse> => {
  const { data } = await client.mutate({
    mutation: VERIFY_EMAIL,
    variables: { email, submissionCode },
    fetchPolicy: 'network-only',
  });

  return data.verifyEmail;
};
